import React from 'react';

var KiotSpinner = null;
import TextField from 'material-ui/TextField';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton';
import Box from '../ui/Box';

import DataService from '../../services/DataService'; var ds = DataService;
import LocalStorageService from '../../services/LocalStorageService'; var ls = LocalStorageService;

export default class NewTelephoneNumber extends React.Component {
  constructor(props) {
    super(props);
    let x = new Date();
    this.state = {
      name: this.props.details ? this.props.details.name : "",
      number: this.props.details ? this.props.details.number : "",
      spinner: null,
      dialog: {
        open: false,
        head: 'Dude',
        body: 'This is working',
        actions: [
          <FlatButton
            label="Okay"
            primary
            onClick={this.closeDialog.bind(this)}
          />
        ]
      }
    };
  }

  handleChanges(e) {
    this.setState({
      [e.target.name]: e.target.value
    });
  }

  closeDialog() {
    this.setState({
      dialog: {
        head: '',
        body: '',
        open: false,
        actions: []
      }
    })
  }

  handleChange = (e, index, value) => this.setState({ 'room_num': value });

  createTelephoneNumber(e) {
    e.preventDefault()
    if (this.validated()) {

      this.setState({
        spinner: <KiotSpinner />
      })

      if (this.props.details && this.props.details._id) {
        ds.postEditTelephoneNumber({
          name: this.state.name,
          number: this.state.number,
          hotel_id: ls.getUserDetails().hotel_id,
          contact_id: this.props.details._id
        }, 
        data => {
          this.props.unMountMe(true);
          this.setState({
            name: "",
            number: "",
            spinner: null
          });
        }, 
        err => {})

      } else {
        ds.postCreateTelephoneNumber({
          name: this.state.name,
          number: this.state.number,
          hotel_id: ls.getUserDetails().hotel_id
        }, 
        data => {
          let dialog = {
            open: true,
            head: 'Success',
            body: "Number added",
            actions: [
              <FlatButton
                label="Okay"
                primary
                onClick={this.closeDialog.bind(this)}
              />
            ]
          }
          let evt = new CustomEvent('updateDirectoryTable', { detail: true });
          window.dispatchEvent(evt);
          this.setState({
            name: '',
            number: '',
            dialog: dialog
          });

        }, err => {
          this.setState({
            spinner: null
          });
        });
      }
    }
  }

  validated() {
    let dialog;
    let flag = true;
    if (!this.state.name || !this.state.number) {
      dialog = {
        open: true,
        head: 'Invalid',
        body: "All Fields are mandatory",
        actions: [
          <FlatButton
            label="Okay"
            primary
            onClick={this.closeDialog.bind(this)}
          />
        ]
      }
      flag = false;
    }

    if (!flag) {
      this.setState({
        dialog: dialog
      })
    }
    return flag;
  }

  render() {
    return (
      <Box header={this.props.details && this.props.details._id ? 'Edit Telephone Number' : 'Telephone Directory'}>
        <Dialog
          title={this.state.dialog.head}
          autoScrollBodyContent={true}
          actions={this.state.dialog.actions}
          modal={false}
          open={this.state.dialog.open}
          onRequestClose={this.closeDialog.bind(this)}
        >
          {this.state.dialog.body || 'NA'}
        </Dialog>

        <div className="col-sm-12">
          <form className="smart-form " onSubmit={this.createTelephoneNumber.bind(this)}>
            <fieldset>
              <section>
                <TextField
                  floatingLabelText="Name"
                  name="name"
                  className="w-100"
                  value={this.state.name}
                  onChange={this.handleChanges.bind(this)}
                />
              </section>

              <section>
                <TextField
                  floatingLabelText="Number"
                  name="number"
                  className="w-100"
                  type="number"
                  value={this.state.number}
                  onChange={this.handleChanges.bind(this)}
                />
              </section>
            </fieldset>

            <div className="mt-4vw align-right">
              <RaisedButton
                label="Save"
                primary
                type="submit"
              />

              <span className="space"></span>

              {
                this.props.details ?
                  <FlatButton
                    label="Cancel"
                    primary
                    onClick={this.props.unMountMe.bind(this, false)}
                    type="button"
                  /> 
                : null
              }
            </div>
          </form>

        </div>
      </Box>
    )
  }
}


// WEBPACK FOOTER //
// ./components/telephone/NewTelephoneNumber.js